module.exports = __webpack_public_path__ + "static/media/selec-nft-10.1f78d449.png";